<template>
  <div class="container">
    <h3 class="title">Dla kogo wizyta?</h3>
    <div class="btn-group">
      <button type="button" class="btn full" :style="{ background: $color }" @click="btnHandler('Dla Ciebie')">Dla Ciebie</button>
    </div>
    <div class="btn-group">
      <button type="button" class="btn full" :style="{ background: $color }" @click="btnHandlerChild('Dziecko')">Dziecko</button>
    </div>
    <div class="btn-group">
      <button type="button" class="btn full" :style="{ background: $color }" @click="btnHandlerOther('Inna osoba')">Inna osoba</button>
    </div>
    <modal name="date-modal" :width="500" class="date-modal">
      <button @click="$modal.hide('date-modal')" class="modal-close">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.5999 1.40002L7.9999 8.00002M1.3999 14.6L7.9999 8.00002M7.9999 8.00002L1.3999 1.40002M7.9999 8.00002L14.5999 14.6" :stroke="$color" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </button>
      <h4 class="modal-subtitle">Podaj datę urodzenia dziecka</h4>
      <datepicker monday-first :inline="true" v-model="date" calendar-class="calendar" :style="{ color: $color }"/>
      <div class="btn-group">
        <button type="button" class="btn" :style="{ background: $color }" @click="saveHandler">Podaj dane</button>
      </div>
    </modal>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js"
export default {
  name: "StepMedicalHome",
  data () {
    return {
      date: null
    }
  },
  components: {
    Datepicker
  },
  methods: {
    ...mapMutations(['setUserData', 'setAssistanceStep', 'setStep']),
    btnHandler (VisitFor) {
      this.setUserData({ VisitFor })
      this.setAssistanceStep('medicalSymptoms')
    },
    saveHandler () {
      const pad = (n) => {return (n<10? '0' :  '') + n}
      const dateFormatted = pad(this.date.getUTCDate()) + '-' + pad(this.date.getUTCMonth() + 1) + '-' + this.date.getUTCFullYear();
      this.setUserData({ ChildBirthDate: dateFormatted })
      const today = new Date();
      let age = today.getFullYear() - this.date.getFullYear();
      const m = today.getMonth() - this.date.getMonth();
      if (m < 0 || (m === 0 && today.getDate() < this.date.getDate())) {
          age--
      }
      if (age > 15) {
        this.btnHandlerOther('Dziecko')
      } else {
        this.setUserData({ VisitFor: 'Dziecko' })
        this.setStep({ index: 3, step: { text: 'Objawy/Dolegliwości', value: 'medicalSymptoms' }})
        this.setAssistanceStep('additional')
      }
    },
    btnHandlerOther (VisitFor) {
      this.setUserData({ VisitFor })
      this.setAssistanceStep('medicalOtherPerson')
    },
    btnHandlerChild (VisitFor) {
      this.setUserData({ VisitFor })
      this.$modal.show('date-modal')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/StepMedicalHome.vue